import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numberOnly]'
})
export class NumberOnlyDirective {
  @Input() numberOnly: Boolean;
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowDown', 'ArrowUp', "ArrowLeft", "ArrowRight","Delete"];
  private regex = /^[0-9]*$/;
  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.numberOnly) {
      // Allow Backspace, tab, end, and home keys
      if (this.specialKeys.indexOf(event.key) !== -1) {
        return;
      }
      let current: string = this.el.nativeElement.value;
      let next: string = current.concat(event.key);
      if (next && !String(next).match(this.regex)) {
        event.preventDefault();
      }
    }
  }
  
}
